<template>
    <div>
        <h1>发展历程</h1>
        <hr>

        <el-form :model="form" ref="form" label-width="100px" class="demo-dynamic">
                        <el-form-item label="">
                            <el-radio-group v-model="radio1" >
                                <el-radio-button label="中文简体"></el-radio-button>
                                <el-radio-button label="中文繁体"></el-radio-button>
                                <el-radio-button label="英文"></el-radio-button>
                                <el-radio-button label="德文"></el-radio-button>
                            </el-radio-group>

                        </el-form-item>
            <el-form-item
                    v-for="(domain, index) in form.domains"
                    :label="'发展历程'"
                    :key="domain.key"
                    :prop="'domains.' + index + '.value'"

            >
                <el-input class="time" v-model="domain.icon"></el-input><i>-</i><el-input v-model="domain.navName" class="value"></el-input><el-button @click.prevent="removeDomain(domain)">删除</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('form')">提交</el-button>
                <el-button @click="addDomain">新增历程</el-button>
<!--                <el-button @click="resetForm('form')">重置</el-button>-->
            </el-form-item>
        </el-form>

    </div>
</template>



<script>
    import request from "@/utils/request";


    export default {

        data() {
            return {
                radio1:"中文简体",
                textarea:"",
                form: {
                    domains: [],
                    ch:[],
                    cht:[],
                    en:[],
                    de:[],

                },
                
            };
        },
        methods: {
            submitForm(formName) {
                if (this.radio1=="中文简体"){
                    this.form.ch=this.form.domains
                }else if(this.radio1=="中文繁体"){
                    this.form.cht=this.form.domains
                }else if(this.radio1=="英文"){
                    this.form.en=this.form.domains
                }else {
                    this.form.de=this.form.domains

                }

                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        request.put("/about_magangent/updateHistory",this.form).then(res => {
                            if (res.code==200){
                                this.$message({
                                    type: 'success',
                                    message: res.data
                                });
                            }else {
                                this.$message({
                                    type: 'warning',
                                    message: res.data
                                });
                            }
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            removeDomain(item) {
                var index = this.form.domains.indexOf(item)
                if (this.radio1=="中文简体"){
                    if (this.form.ch[index].id!=0){
                        this.move(this.form.ch[index].id)
                    }
                }else if (this.radio1=="中文繁体"){
                    if (this.form.cht[index].id!=0){
                        this.move(this.form.cht[index].id)
                    }
                }else if(this.radio1=="英文"){
                    if (this.form.en[index].id!=0){
                        this.move(this.form.en[index].id)
                    }
                }else {
                    if (this.form.de[index].id!=0){
                        this.move(this.form.de[index].id)
                    }
                }
                if (index !== -1) {
                    this.form.domains.splice(index, 1)
                }
            },
            addDomain() {
                this.form.domains.push({
                    icon:'',
                    navName: '',
                    id:0,
                    module:"about",
                    parentId:0,
                    type:'yearsList',
                    sort:50,

                });
            },
            move(id){
                request.delete("/about_magangent/"+id).then(res => {
                    if (res.code==200){

                        this.$message({
                            type: 'success',
                            message: res.data
                        });




                    }else {

                    }


                })
            }
        },
        mounted() {
            let that=this;
            request.get("/about_magangent/getHistory").then(res => {
                if (res.code==200){
                                for (let i = 0; i <res.data.length ; i++) {

                                    if (res.data[i].language=="zh"){
                                        let data={
                                            navName:res.data[i].navName,
                                            icon:res.data[i].icon,
                                            id:res.data[i].id,
                                            module:res.data[i].module,
                                            guide:res.data[i].guide,
                                            parentId:res.data[i].parentId,
                                            type:res.data[i].type,
                                            sort:res.data[i].sort,
                                        language:res.data[i].language,
                                        }
                                        that.form.ch.push(data)
                                        that.form.domains=that.form.ch
                                    }else if(res.data[i].language=="cht"){
                                        let data={
                                            navName:res.data[i].navName,
                                            icon:res.data[i].icon,
                                            id:res.data[i].id,
                                            module:res.data[i].module,
                                            guide:res.data[i].guide,
                                            parentId:res.data[i].parentId,
                                            type:res.data[i].type,
                                            sort:res.data[i].sort,
                                            language:res.data[i].language,

                                        }
                                        that.form.cht.push(data)
                                    }else if(res.data[i].language=="en"){
                                        let data={
                                            navName:res.data[i].navName,
                                            icon:res.data[i].icon,
                                            id:res.data[i].id,
                                            module:res.data[i].module,
                                            guide:res.data[i].guide,
                                            parentId:res.data[i].parentId,
                                            type:res.data[i].type,
                                            sort:res.data[i].sort,
                                            language:res.data[i].language,

                                        }
                                        that.form.en.push(data)
                                    }else{
                                        let data={
                                            navName:res.data[i].navName,
                                            icon:res.data[i].icon,
                                            id:res.data[i].id,
                                            module:res.data[i].module,
                                            guide:res.data[i].guide,
                                            parentId:res.data[i].parentId,
                                            type:res.data[i].type,
                                            sort:res.data[i].sort,
                                            language:res.data[i].language,

                                        }
                                        that.form.de.push(data)
                                    }
                                }





                            }else {

                            }


                        })


        },
        watch:{

                radio1(news,old){
                    if (old != news){

                        if (old=="中文简体"){
                            this.form.ch=this.form.domains
                        }else if(old=="中文繁体"){
                            this.form.cht=this.form.domains
                        }else if(old=="英文"){
                            this.form.en=this.form.domains
                        }else {
                            this.form.de=this.form.domains

                        }
                        if (news=="中文简体"){
                            this.form.domains=this.form.ch
                        }else if(news=="中文繁体"){
                            this.form.domains=this.form.cht
                        }else if(news=="英文"){
                            this.form.domains=this.form.en
                        }else {
                            this.form.domains=this.form.de

                        }
                    }
                }

            },
    }


</script>

<style scoped>
    .time{
        width: 10%;
    }
    .value{
        width: 50%;
    }
</style>